export function getLeadtimeResult(leadtime: number): 'high' | 'low' {
  const variance = 15 / 100;
  const threshold = leadtime + leadtime * variance;

  const surpass = threshold >= 30;

  return surpass ? 'high' : 'low';
}
